<template>
  <section class="bg-white dark:bg-gray-900">
    <div class="mx-auto max-w-screen-xl px-4 py-8 lg:px-6 lg:py-16">
      <div class="mx-auto max-w-screen-sm text-center">
        <AtomText
          :text="$t('authentication.loginFailed.title')"
          font-size="text-4xl"
          font-style="font-bold"
          class="mb-4"
        />
        <AtomText
          :text="$t('authentication.loginFailed.description')"
          font-size="text-lg"
          font-style="font-light"
          class="mb-4"
        />
      </div>
    </div>
  </section>
</template>

<script lang="ts" setup></script>
